<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <div class="usa-legend usa-legend--large">Bid Cycle Name: {{rateBidCycleName}}</div>
    </div>
  </div>
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <tabset class="maxw-full">
        <tab heading="FRT View Rates" id="tab1" (selectTab)="onSelectTab($event)">
          @if (this.activeTab === 'zero' || showViewRate) {
            <app-frt-rates-download></app-frt-rates-download>
          }
        </tab>
        <tab heading="FRT Template Download" id="tab2" (selectTab)="onSelectTab($event)">
          @if (this.activeTab === 'one') {
            <app-frt-template-download></app-frt-template-download>
          }
        </tab>
        <tab heading="FRT Upload Rate File" id="tab3" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
          @if (this.activeTab === 'two') {
            <app-upload [businessType]="'frt'"></app-upload>
          }
        </tab>
        <tab heading="FRT Edit Rates" id="tab4" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
          @if (this.activeTab === 'three') {
            <app-frt-rate-edit></app-frt-rate-edit>
          }
        </tab>
        <tab heading="FRT Global Update" id="tab5" (selectTab)="onSelectTab($event)" [disabled]="isRateFilingClosed$ | async">
          @if (this.activeTab === 'four') {
            <app-frt-rate-global-update></app-frt-rate-global-update>
          }
        </tab>
      </tabset>
    </div>
  </div>
</div>
